/**
 * How full the blue bar is. The bar's width is the player's shield ceiling,
 * so a mode whose max is 50 draws full at 50. A missing ceiling falls back
 * to 100, matching the bar's historical fixed scale.
 */
export function shieldFillRatio(shieldValue, maxShield) {
  const value = Math.max(0, shieldValue || 0);
  const max = Number.isFinite(maxShield) ? maxShield : 100;
  if (max <= 0) return 0;
  return Math.min(1, value / max);
}
